import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from 'src/app/helper/string/string-helper';

@Pipe({
	name: 'phone',
})
export class PhonePipe implements PipeTransform {
	transform(value: string, code: number = null): unknown {
		return StringHelper.phone(value, (code && code.toString()) || null);
	}
}
